import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import { CircularProgress } from "@material-ui/core";
import { fetchRedirectionParams } from "../../../actions/redirect";
import "./WalletForm.css";

import { FormatAmount } from "../../../utils/Formatter";
import { calculateAmount } from "../../../utils/SurchargeUtils";
import PAYTMLogo from "./Paytm.svg";
import AmazonPayLogo from "./AmazonPay.svg";
import PhonePeLogo from "./PhonePe.svg";

const useStyles = makeStyles(({ palette }) => {
  return {
    selectedwallet: {
      transform: "scale(1.13, 1.13)",
      textAlign: "center",
      transition: "all ease-in-out 100ms",
      color: palette.text.primary,
      "& div": {
        borderBottom: `2px solid ${palette.secondary.main}`
      }
    },
    payBtnColor: {
      color: palette.success.main,
      borderColor: palette.success.main,
      border: `solid`
    }
  };
});

const walletList = [
  { icon: PAYTMLogo, name: "PAYTM" },
  { icon: AmazonPayLogo, name: "AMAZONPAY" },
  { icon: PhonePeLogo, name: "PHONEPE" }
];

export const WalletForm = ({ charge, dispatch, redirecting }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { uuid, due, currency, paymentFamilies, feeRenderMode } = charge;
  const { wallets, surcharges } = paymentFamilies;
  const [form, setForm] = useState({
    walletName: undefined
  });

  const totalAmount = FormatAmount(
    calculateAmount(due, location.pathname, surcharges, feeRenderMode),
    currency
  );

  const submitWalletForm = () => {
    dispatch(fetchRedirectionParams(uuid, form, "wallet", history));
  };

  return (
    <div>
      <Grid justify="center" container spacing={2} className="wallets-grid">
        {walletList.map(wallet => {
          const isSelected = form.walletName === wallet.name;
          if (wallets.includes(wallet.name)) {
            return (
              <Grid
                item
                xs={6}
                sm={3}
                className={isSelected ? classes.selectedwallet : "wallet"}
                key={wallet.name}
                id={wallet.name}
                onClick={() => {
                  setForm({ ...form, walletName: wallet.name });
                }}
              >
                <Card
                  elevation={isSelected ? 3 : 1}
                  id={`wallet-${wallet.name}`}
                >
                  <CardActionArea>
                    <img
                      alt={wallet.name}
                      src={wallet.icon}
                      className="wallet-icon"
                    />
                  </CardActionArea>
                </Card>
              </Grid>
            );
          }
          return null;
        })}
      </Grid>
      <Grid item xs={12} style={{ textAlign: "center" }}>
        <Button
          id="pay-button"
          variant="outlined"
          color="primary"
          className={classes.payBtnColor}
          onClick={submitWalletForm}
          disabled={!form.walletName || redirecting}
        >
          {redirecting ? (
            <CircularProgress color="inherit" size={30} />
          ) : (
            `Pay ${totalAmount}`
          )}
        </Button>
      </Grid>
    </div>
  );
};

WalletForm.propTypes = {
  charge: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    due: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    feeRenderMode: PropTypes.string,
    paymentFamilies: PropTypes.shape({
      wallets: PropTypes.arrayOf(PropTypes.string).isRequired,
      surcharges: PropTypes.arrayOf(PropTypes.shape())
    }).isRequired
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  redirecting: PropTypes.bool.isRequired
};

function mapStateToProps({ redirectionReducer }) {
  return redirectionReducer;
}

export default connect(mapStateToProps)(WalletForm);
